import { EdState, INITIAL_ED_STATE } from "../ed";
import { DesktopState } from "@/components/desktopState";
import { userland } from "./userland";
import helpStory from "./HELP.txt";

const initialDesktopState: DesktopState = {
  tool: "HAND",
  volume: "NOISY",
  teletype: {
    line: "",
    activePaper: []
  },
  pinboard: {
    papers: [
    ]
  },
  help: helpStory,
  turboSpeed: 80,
  version: 1
};

let initialEdState: EdState = {
  ...INITIAL_ED_STATE,
  files: {
    ...userland,
  }
};

export const blank = {
  id: "blank",
  initialDesktopState,
  initialEdState
};
